// extracted by mini-css-extract-plugin
export default {"container":"style_container__4Hi4T","center_label":"style_center_label__fQT8R"};